export class MenuItem {

    // Properties
    itemName: string;
    data?: any;
    childItems?: MenuItem[];;
    disabled?: boolean;


    // Class Functions
    constructor(itemName: string, data?: any) {
        this.itemName = itemName;
        this.data = data;
    }
}
